import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Accordion } from "react-bootstrap";

const ChartsSection = ({
  columnChartConfig = {},
  priorityChartConfig = {},
  timelineChartConfig = {},
  tasks = [],
}) => {
  console.log(priorityChartConfig);
  // ✅ Moved useMemo inside the component
  const chartConfigurations = useMemo(
    () => ({
      columnChart: {
        chart: { type: "column" },
        title: { text: "Tasks by Status" },
        xAxis: { type: "category" },
        yAxis: { title: { text: "Number of Tasks" } },
        legend: { enabled: false },
        plotOptions: {
          series: {
            pointPadding: 0.4,
            borderWidth: 0,
            dataLabels: { enabled: true },
          },
        },
        series: [
          {
            name: "Tasks",
            colorByPoint: true,
            data: [
              {
                name: "Work In Progress",
                y: columnChartConfig?.workInProgress,
                color: "#FFC107",
              },
              {
                name: "On Time",
                y: columnChartConfig?.onTime,
                color: "#28A745",
              },
              {
                name: "Slight Delay",
                y: columnChartConfig?.slightDelay,
                color: "#FD7E14",
              },
              {
                name: "Significant Delay",
                y: columnChartConfig?.significantDelay,
                color: "#DC3545",
              },
            ],
          },
        ],
      },
      priorityChart: {
        chart: { type: "pie" },
        title: { text: "Tasks by Priority" },
        series: [
          {
            name: "Tasks",
            data: [
              { name: "Top", y: priorityChartConfig.top, color: "#DC3545" },
              { name: "High", y: priorityChartConfig.high, color: "#FD7E14" },
              {
                name: "Medium",
                y: priorityChartConfig.medium,
                color: "#6C757D",
              },
              {
                name: "Low",
                y: priorityChartConfig.low,
                color: "#256DF0",
              },
            ],
          },
        ],
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
            },
          },
        },
      },
      timelineChart: {
        chart: { type: "spline" },
        title: { text: "Weekly Task Progress" },
        xAxis: { categories: ["Week 1", "Week 2", "Week 3", "Week 4"] },
        yAxis: { title: { text: "Number of Tasks" } },
        series: [
          {
            name: "Top Priority",
            data: timelineChartConfig?.topTasksWeekly,
            color: "#DC3545",
          },
          {
            name: "High Priority",
            data: timelineChartConfig?.highTasksWeekly,
            color: "#FD7E14",
          },
          {
            name: "Medium Priority",
            data: timelineChartConfig?.mediumTasksWeekly,
            color: "#6C757D",
          },
          {
            name: "Low Priority",
            data: timelineChartConfig?.lowTasksWeekly,
            color: "#256DF0",
          },
        ],
      },
    }),
    [priorityChartConfig, timelineChartConfig, columnChartConfig]
  );

  const safeColumnConfig = {
    ...columnChartConfig,
    series: columnChartConfig.series || [
      {
        name: "Tasks",
        data: [],
      },
    ],
  };

  const safePriorityConfig = {
    ...priorityChartConfig,
    series: priorityChartConfig.series || [
      {
        name: "Tasks",
        data: [],
      },
    ],
  };

  const safeTimelineConfig = {
    ...timelineChartConfig,
    series: timelineChartConfig.series || [],
  };

  return (
    <div className="container pdbtm40 px-0 mt-5">
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="1">
          <Accordion.Header className="accourdianheading">
            Overall Tasks
          </Accordion.Header>
          <Accordion.Body className="pb-5">
            <div className="row">
              <div className="card pdbtm40">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={chartConfigurations.columnChart}
                />
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-6 col-12 pdlnone ps-0">
                <div className="card">
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={chartConfigurations.priorityChart}
                  />
                </div>
              </div>
              <div className="col-md-6 col-12 pe-0">
                <div className="card">
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={chartConfigurations.timelineChart}
                  />
                </div>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default ChartsSection;
